import {Table, Form, Space, Radio, Badge, Flex, InputNumber, DatePicker, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import LoanCheck from './LoanCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './loan.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import UserSelect from '../../system/user/UserSelect';
function LoanListAll(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "jk_state": '',     
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.slice();
            if(query.jk_state){
              arr = arr.filter((item) => item.jk_state === query.jk_state);
            }      
            if(query.jk_amount){
              arr = arr.filter((item) => Number(item.jk_amount) === Number(query.jk_amount));
            }
            if(query.jk_kh_id){
              arr = arr.filter((item) => Number(item.jk_kh_id) === Number(query.jk_kh_id));
            }
            if(query.jk_date){
              arr = arr.filter((item) => dayjs(item.jk_date).format('YYYY-MM-DD') === query.jk_date);
            }
            if(query.jk_uid){
              arr = arr.filter((item) => item.jk_uid === query.jk_uid);
            }
            if(query.jk_id){
              arr = arr.filter((item) => item.jk_id === query.jk_id);
            }
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.jk_id
            }));
            arr.sort((a, b) => new Date(b.jk_ctime) - new Date(a.jk_ctime));
            setList(arr);
        }
    }, [props.list, props.yh_id, query])
    
    const columns = [    
        {
            title: '借款客户',  
            dataIndex: 'jk_kh_name',
            width: '12%',
            key: 'jk_kh_name',         
            render: (text, record) =><LoanCheck
                                        type='button'
                                        jk_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        jk_bzd_id={record.jk_bzd_id}
                                        jk_price={record.jk_price}
                                        jk_content={record.jk_content}
                                        jk_date={record.jk_date}
                                        jk_date_end={record.jk_date_end}
                                        jk_bzd_name={record.jk_bzd_name}
                                        jk_bzd_danhao={record.jk_bzd_danhao}
                                        jk_type_id={record.jk_type_id}
                                        jk_type_name={record.jk_type_name}
                                        jk_kh_id={record.jk_kh_id}
                                        jk_kh_name={record.jk_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        jk_num={record.jk_num}
                                        jk_amount={record.jk_amount}
                                        jk_state={record.jk_state}
                                        jk_bm_id={record.jk_bm_id}
                                        jk_bm_name={record.jk_bm_name}
                                        jk_khyhzh_id={record.jk_khyhzh_id}
                                        jk_khyhzh_name={record.jk_khyhzh_name}
                                        jk_image_name={record.jk_image_name}
                                        jk_image_file={record.jk_image_file}
                                        jk_ctime={record.jk_ctime}
                                        jk_uid={record.jk_uid}
                                        yh_qx={props.yh_qx}
                                    />
        },
        {
            title: '借款金额',
            dataIndex: 'jk_amount',
            width: '10%',
            key: 'jk_amount',   
                render: (text, record) => <span style={{color:'#660099'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'jk_content',
            key:'jk_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"jk_bzd_danhao",
            key:'jk_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.jk_bzd_name} dsbzd_id={record.jk_bzd_id} dsbzd_danhao={record.jk_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },  
        {
            title: '提交记录',
            dataIndex: 'jk_ctime',
            key:'jk_ctime',
            render:(text,record) => {
                return <span>{record.jk_uname} {record.jk_ctime}</span>
            }
        },    
        {
            title: '状态',
            dataIndex: 'jk_state',
            width: '5%',
            key: 'jk_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_loan_list_all'
                    form={form}
                    initialValues={{                        
                        jk_state: query.jk_state ? query.jk_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            jk_state: values.jk_state ? values.jk_state : '',
                            jk_kh_id: values.jk_kh_id ? values.jk_kh_id : '',
                            jk_name: values.jk_name ? values.jk_name : '',
                            jk_date: values.jk_date ? values.jk_date : '',
                            jk_uid: values.jk_uid ? values.jk_uid : '',
                            jk_id: values.jk_id ? values.jk_id : '',
                            jk_amount: values.jk_amount ? values.jk_amount : '',
                        };
                        setQuery(prev => ({ ...prev, ...serializedValues }));
                        
                        localStorage.setItem('jtg-caiwu_loanList_jk_state', JSON.stringify(serializedValues.jk_state));
                        localStorage.setItem('jtg-caiwu_loanList_jk_kh_id', JSON.stringify(serializedValues.jk_kh_id));
                        localStorage.setItem('jtg-caiwu_loanList_jk_name', JSON.stringify(serializedValues.jk_name));
                        localStorage.setItem('jtg-caiwu_loanList_jk_date', JSON.stringify(serializedValues.jk_date));
                        localStorage.setItem('jtg-caiwu_loanList_jk_uid', JSON.stringify(serializedValues.jk_uid));
                        localStorage.setItem('jtg-caiwu_loanList_jk_id', JSON.stringify(serializedValues.jk_id));
                        localStorage.setItem('jtg-caiwu_loanList_jk_amount', JSON.stringify(serializedValues.jk_amount));
                    }}
                >
                    <Form.Item 
                        name='jk_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    jk_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_loanList_jk_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Radio value='5' >已结束（未读）</Radio>
                            <Radio value='6' >已结束（已读）</Radio>
                        </Radio.Group>        
                    </Form.Item>    
                    <Form.Item name='jk_amount' wrapperCol={{ offset: 2 }}>
                        <InputNumber
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, jk_amount: value }));
                            }}
                            value={query.jk_amount ? query.jk_amount : undefined}
                            placeholder='借款单金额'
                            name='jk_amount'
                            style={{ width: '120px' }}
                        />
                    </Form.Item> 
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, jk_kh_id: '' })) }}
                        placeholder='借款单客户'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='jk_kh_id'
                        onChange={(khId) => { setQuery(prev => ({ ...prev, jk_kh_id: khId || '' })) }}
                        yh_id={props.yh_id}
                        list={props.commonList?.kf_data || props.commonList?.kh_data || []}
                        wrapperCol={{ span: 18 }}
                    />  
                    <Form.Item name='jk_date'>
                        <DatePicker 
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, jk_date: dayjs(value).format('YYYY-MM-DD') }));
                            }}
                            value={query.jk_date ? dayjs(query.jk_date) : null}
                            allowClear={true}
                            placeholder='借款单日期'
                            name='jk_date'
                        />
                    </Form.Item>          
                    <UserSelect
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, jk_uid: '' })) }}
                        placeholder='操作员'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='jk_uid'
                        onChange={(e) => {setQuery(prev => ({ ...prev, jk_uid: e.yh_id || '' }))}}
                    />
                    <Form.Item name='jk_id' >
                        <Input placeholder='借款单编号' onChange={(e) => {setQuery(prev => ({ ...prev, jk_id: e.target.value || '' }))}} style={{ width: "100px" }} />
                    </Form.Item>
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_expenseList_jk_state', JSON.stringify(''))
                                    setQuery({
                                        "jk_state": '',
                                        jk_kh_id: '',
                                        jk_amount: undefined,
                                        jk_uid: '',
                                        jk_date: '',
                                        jk_id: '',
                                    })
                                    form.setFieldsValue({
                                        jk_name: null,
                                        jk_kh_id: null,
                                        jk_bzd_danhao: null,
                                        jk_uid: null,
                                        jk_date: null,
                                        jk_id: '',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.jk_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'#660099'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无付款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default LoanListAll